<template>
  <div class="invite-tab-bar">
    <div
      class="invite-tab-bar__tab"
      :class="{ 'invite-tab-bar__tab--active': currentTab === 'invite' }"
      @click="$emit('tab-change', 'invite')"
    >
      <span :class="currentTab === 'invite' ? 'typo-body-m-bold' : 'typo-body-m-medium'">초대하기</span>
    </div>
    <div
      class="invite-tab-bar__tab"
      :class="{ 'invite-tab-bar__tab--active': currentTab === 'code' }"
      @click="$emit('tab-change', 'code')"
    >
      <span :class="currentTab === 'code' ? 'typo-body-m-bold' : 'typo-body-m-medium'">초대코드 입력</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteTabBar',
  props: {
    currentTab: {
      type: String,
      default: 'invite',
    },
  },
}
</script>

<style scoped>
.invite-tab-bar {
  display: flex;
  width: 100%;
  background: #FFF;
  border-bottom: 1px solid #D1D6DB;
}

.invite-tab-bar__tab {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
}

.invite-tab-bar__tab--active {
  border-bottom: 2px solid var(--color-text-main, #191F28);
}

.invite-tab-bar__tab--active span {
  color: var(--color-text-main, #191F28);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/InviteTabBar.vue